import { motion } from "framer-motion";
import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/3577a7b5-9f96-43ae-ab15-790d83dbe3b9" +
  "?include=field_imagen_portada.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

// Variantes para el contenedor principal (Stagger)
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.18,
    },
  },
};

// Variantes para los elementos individuales
const itemVariants = {
  hidden: { opacity: 0, y: 25 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.1, 0.25, 1], // Transition curva suave (cubic-bezier)
    },
  },
};

// 1. Recibimos la prop 'value' aquí
function SegundaTitulacionEscuelaNegocios({ value }) {
  // Convertimos a String para evitar fallos si mandas number (1) o string ("1")
  const isOnlyBlockOne = String(value) === "1";

  const DataDisplay = ({ data }) => (
    <section className="bluebg relative overflow-hidden text-white py-16 md:py-24">
      <motion.div
        className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
      >
        {/* Título / Texto Portada */}
        <motion.div
          variants={itemVariants}
          className="mb-12 text-center max-w-3xl mx-auto
            /* Estilos para badges o subtítulos dentro de data.texto_portada */
            [&_h4]:inline-flex
            [&_h4]:items-center
            [&_h4]:bg-white/15
            [&_h4]:text-white
            [&_h4]:backdrop-blur-md
            [&_h4]:border
            [&_h4]:border-white/20
            [&_h4]:rounded-full
            [&_h4]:px-5
            [&_h4]:py-2
            [&_h4]:text-xs
            [&_h4]:font-semibold
            [&_h4]:tracking-wide
            [&_h4]:uppercase
            [&_h4]:shadow-sm
            /* Formato tipográfico general */
            [&_h2]:font-bold  
            [&_p]:text-white/85"
          dangerouslySetInnerHTML={{
            __html: data.texto_portada,
          }}
        />

        {/* Grid de Bloques */}
        {/* Cambiamos el grid a 1 sola columna si isOnlyBlockOne es true */}
        <div
          className={`grid gap-8 items-stretch ${
            isOnlyBlockOne
              ? "grid-cols-1 max-w-2xl mx-auto"
              : "grid-cols-1 md:grid-cols-2"
          }
            /* Estilos globales para enlaces/botones inyectados */
            [&_a]:inline-flex
            [&_a]:items-center
            [&_a]:justify-center
            [&_a]:bg-[#febe10]
            [&_a]:text-[#004270]
            [&_a]:px-6
            [&_a]:py-3
            [&_a]:rounded-full
            [&_a]:font-bold
            [&_a]:text-sm
            [&_a]:shadow-md
            [&_a]:transition-all
            [&_a]:duration-200
            [&_a]:hover:bg-yellow-400
            [&_a]:hover:shadow-xl
            [&_a]:hover:scale-[1.02]
            [&_a]:active:scale-[0.98]
            [&_a]:mt-6
            [&_h3]:font-bold`}
        >
          {/* Bloque 1 */}
          <motion.div
            variants={itemVariants}
            whileHover={{
              y: -8,
              transition: { duration: 0.25, ease: "easeOut" },
            }}
            className="flex flex-col justify-between p-8 rounded-2xl border border-white/20 bg-white/10 backdrop-blur-md shadow-lg hover:shadow-2xl hover:border-white/40 transition-all duration-300"
            dangerouslySetInnerHTML={{
              __html: data.bloque1,
            }}
          />

          {/* Bloque 2 - Se renderiza SOLO SI value NO es "1" */}
          {!isOnlyBlockOne && (
            <motion.div
              variants={itemVariants}
              whileHover={{
                y: -8,
                transition: { duration: 0.25, ease: "easeOut" },
              }}
              className="flex flex-col justify-between p-8 rounded-2xl border border-white/20 bg-white/10 backdrop-blur-md shadow-lg hover:shadow-2xl hover:border-white/40 transition-all duration-300"
              dangerouslySetInnerHTML={{
                __html: data.bloque2,
              }}
            />
          )}
        </div>
      </motion.div>
    </section>
  );

  return (
    <DataFetcherTemplateHome url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcherTemplateHome>
  );
}

export default SegundaTitulacionEscuelaNegocios;